import React, { useState, useEffect } from "react";
import { useHistory, useParams } from "react-router";
import { makeStyles } from "@mui/styles";
import ChevronLeftOutlinedIcon from "@mui/icons-material/ChevronLeftOutlined";
import BusinessOfferCard from "./BusinessOfferCard";
import BusinessProducts from "./BusinessProducts";

import {
  GetBusinessInfo,
  GetListOfferProducts,
} from "../Business/Infrastructure/Business.presenter";


const useStyles = makeStyles((theme) => ({
  principalContainer: {
    //paddingTop: 80,
    minHeight: "100vh",
    height: "auto",
    padding: "23px 19px",
    background: "#ffffff",
    paddingBottom: 35,
  },
  root: {
    display: "grid",
    gridTemplateColumns: "1.20fr 2fr",
    width: "100%",
    maxWidth: "1164px",
    top: "16%",
    left: "13.5%",
    marginTop: "auto",
    gap: "20px 40px",
    [theme.breakpoints.down("lg")]: {
      display: "flex",
      alignItems: "center",
      flexDirection: "column",
    },
  },
  header: {
    display: "flex",
    alignItems: "center",
  },
  productsHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  businessImage: {
    borderRadius: "50%",
    objectFit: "cover",
    width: 66,
    height: 66,
    maxWidth: 66,
    maxHeight: 66,
    marginRight: "20px",
  },
  iconBag: { marginRight: "20px" },
  subtitle: {
    color: "#333333",
    fontWeight: 400,
    fontSize: "1.5rem",
    marginBottom: "10px",
  },
  listProducts: {
    [theme.breakpoints.up("md")]: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: "20px 60px",
    },
  },
  products: { height: "265px" },
  address: {
    height: "46px",
    width: "311px",
    marginTop: "10px",
  },
  offersContainer: {
    padding: "18px 20px 18px 0px",
    display: "flex",
    justifyContent: "flex-start",
    width: "100%",
    //maxWidth: "710px",
    height: "auto",
    //minHeight: "250px",
    background: "#FFFFFF",
    overflowX: "scroll",
  },
  titleInfo: {
    lineHeight: "21.94px",
    fontWeight: 500,
    color: "#333333",
    fontSize: "1.125rem",
  },
  productsContainer: {
    width: "100%",
    height: "auto",
  },
  businessName: {
    fontWeigh: 500,
    fontSize: "1.875rem",
    lineHeight: "36.57px",
    color: "#333333",
    marginBottom: 15,
  },
  headerHelp: {
    marginBottom: 15,
    //padding: "0px 25px 10px 5px",
    //position: "absolute",
    /* top: 15,
    right: 0, */
    width: "100%",
    //order: -6,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    //border: "3px solid red",
    [theme.breakpoints.up("md")]:{
      display: "none"
    },
  },
}));

export default function BusinessProductsOffers() {
  const classes = useStyles();
  const history = useHistory();
  const { id } = useParams();
  const [offers, setOffers] = useState([]);
  const [business, setBusiness] = useState({});
  const [businessRender, setBusinessRender] = useState(false);

  const handleResizeWindow = () => {
    const screenWidth = window.innerWidth;
    if (screenWidth >= 768) {
      history.push(`/negocio/${id}`)
    }
  };

  useEffect(() => {
    if (id) {
      fetchDataBusiness(id);
      getListOffers(id);
      window.addEventListener("resize", handleResizeWindow);
      window.addEventListener("load", handleResizeWindow);
    }
    return () => {
      window.removeEventListener("resize", handleResizeWindow);
      window.addEventListener("load", handleResizeWindow);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  async function fetchDataBusiness(id) {
    try {
      const { valid, info } = await GetBusinessInfo(id);

      if (valid) {
        setBusiness(info);
        setBusinessRender(true);
      } else {
        console("Ha ocurrido un error al obtener la información");
        history.push(`/negocio/${id}`);
      }
    } catch (error) {
      console.log("Ha ocurrido un error");
    }
  }

  async function getListOffers(id) {
    try {
      const { items } = await GetListOfferProducts(id);
      setOffers(items);
    } catch (error) {
      console.log("ha ocurrido un error al obtener las ofertas");
    }
  }

  return (
    <div className={classes.principalContainer}>
      <div className={classes.headerHelp}>
        <ChevronLeftOutlinedIcon
          sx={{
            width: "24px",
            height: "24px",
            display: { md: "none" },
            color: "#004990",
          }}
          onClick={() =>  history.push(`/negocio/${id}`)}
        />
        <h4 style={{ color: "#004990", fontSize: "0.875rem", fontWeigh: 700 }}>
          Ayuda
        </h4>
      </div>
      {offers.length !== 0 && (
        <>
          <h2 className={classes.businessName}>{business.shop_name}</h2>
          <h4 className={classes.titleInfo}>Ofertas</h4>
          <div className={classes.offersContainer}>
            {offers.map((offer) => (
              <BusinessOfferCard
                key={offer.id}
                id={offer.id}
                offerPrice={offer.offerprice}
                realPrice={offer.price}
                name={offer.product_name}
                description={offer.description}
                image={offer.url_image}
                amount={offer.netcontent}
              />
            ))}
          </div>
        </>
      )}
      {businessRender && (
        <div className={classes.productsContainer}>
          <BusinessProducts business={business} />
        </div>
      )}
    </div>
  );
}
